import { Repeater, types } from "react-bricks/frontend"

import React from "react"

export interface TableRowProps {
    isHeader?: boolean
}

const TableRow: types.Brick<TableRowProps> = ({ isHeader }) => {
    {
        return isHeader ? (
            <thead>
                <tr className="bg-darkblumine text-white">
                    <Repeater propName="cells" itemProps={{ isHeader }} />
                </tr>
            </thead>
        ) : (
            <tr className="bg-white odd:bg-background-tide">
                <Repeater propName="cells" />
            </tr>
        )
    }
}

TableRow.schema = {
    name: "TableRow",
    label: "Row",
    hideFromAddMenu: true,
    repeaterItems: [
        {
            name: "cells",
            itemType: "TableCell",
            min: 1,
        },
    ],
    sideEditProps: [
        {
            name: "isHeader",
            label: "Is Header",
            type: types.SideEditPropType.Boolean,
        },
    ],
}

export default TableRow
